/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AnalyticsStepType,
    AnalyticsStepTypeFromJSON,
    AnalyticsStepTypeToJSON,
    AudienceMemberList,
    AudienceMemberListFromJSON,
    AudienceMemberListToJSON,
    Campaign,
    CampaignFromJSON,
    CampaignToJSON,
    CampaignCreateParams,
    CampaignCreateParamsFromJSON,
    CampaignCreateParamsToJSON,
    CampaignList,
    CampaignListFromJSON,
    CampaignListToJSON,
    CampaignScheduleParams,
    CampaignScheduleParamsFromJSON,
    CampaignScheduleParamsToJSON,
    CampaignSendTestParams,
    CampaignSendTestParamsFromJSON,
    CampaignSendTestParamsToJSON,
    CampaignSentResult,
    CampaignSentResultFromJSON,
    CampaignSentResultToJSON,
    CampaignStatus,
    CampaignStatusFromJSON,
    CampaignStatusToJSON,
    CampaignUpdateParams,
    CampaignUpdateParamsFromJSON,
    CampaignUpdateParamsToJSON,
    DateMacro,
    DateMacroFromJSON,
    DateMacroToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    Message,
    MessageFromJSON,
    MessageToJSON,
    SegmentOptions,
    SegmentOptionsFromJSON,
    SegmentOptionsToJSON,
    ShortLink,
    ShortLinkFromJSON,
    ShortLinkToJSON,
    ShortLinkAnalytics,
    ShortLinkAnalyticsFromJSON,
    ShortLinkAnalyticsToJSON,
    ShortLinkCreateParams,
    ShortLinkCreateParamsFromJSON,
    ShortLinkCreateParamsToJSON,
    ShortLinkList,
    ShortLinkListFromJSON,
    ShortLinkListToJSON,
    ShortLinkUpdateParams,
    ShortLinkUpdateParamsFromJSON,
    ShortLinkUpdateParamsToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
} from '../models';

export interface CancelCampaignRequest {
    program_id: string;
    campaign_id: string;
}

export interface CreateCampaignRequest {
    program_id: string;
    CampaignCreateParams: CampaignCreateParams;
}

export interface CreateShortLinkRequest {
    program_id: string;
    ShortLinkCreateParams: ShortLinkCreateParams;
}

export interface DeleteCampaignRequest {
    program_id: string;
    campaign_id: string;
}

export interface DeleteShortLinkRequest {
    program_id: string;
    id: string;
}

export interface FindAudiencesRequest {
    program_id: string;
    SegmentOptions: SegmentOptions;
    sort?: string;
    order?: GetManyOrder;
    skip?: number;
    limit?: number;
    search?: string;
}

export interface FindCampaignsRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    id?: Array<string>;
    sent_lt?: Date;
    sent_gt?: Date;
    sent_lte?: Date;
    sent_gte?: Date;
    scheduled_lt?: Date;
    scheduled_gt?: Date;
    scheduled_lte?: Date;
    scheduled_gte?: Date;
    status?: Array<CampaignStatus>;
    search?: string;
}

export interface FindOneAnalyticsShortLinkRequest {
    program_id: string;
    id: string;
    date_macro: DateMacro;
    unit?: AnalyticsStepType;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
}

export interface FindOneCampaignRequest {
    program_id: string;
    campaign_id: string;
}

export interface FindOneSegmentCampaignRequest {
    program_id: string;
    campaign_id: string;
}

export interface FindOneShortLinkRequest {
    program_id: string;
    id: string;
}

export interface FindShortLinksRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    is_campaign?: boolean;
    campaign_id?: Array<string>;
    unique_clicks_lt?: number;
    unique_clicks_gt?: number;
    unique_clicks_lte?: number;
    unique_clicks_gte?: number;
    clicks_lt?: number;
    clicks_gt?: number;
    clicks_lte?: number;
    clicks_gte?: number;
    search?: string;
    id?: Array<string>;
}

export interface PreviewCampaignRequest {
    program_id: string;
    campaign_id: string;
    contact_id: string;
}

export interface ScheduleCampaignRequest {
    program_id: string;
    campaign_id: string;
    CampaignScheduleParams: CampaignScheduleParams;
}

export interface SendCampaignRequest {
    program_id: string;
    campaign_id: string;
}

export interface SendTestCampaignRequest {
    program_id: string;
    campaign_id: string;
    CampaignSendTestParams: CampaignSendTestParams;
}

export interface UpdateCampaignRequest {
    program_id: string;
    campaign_id: string;
    CampaignUpdateParams: CampaignUpdateParams;
}

export interface UpdateShortLinkRequest {
    program_id: string;
    id: string;
    ShortLinkUpdateParams: ShortLinkUpdateParams;
}

/**
 * 
 */
export class MarketingApi extends runtime.BaseAPI {

    /**
     * Cancel scheduled campaign
     */
    async cancelCampaignRaw(requestParameters: CancelCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Campaign>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling cancelCampaign.');
        }

        if (requestParameters.campaign_id === null || requestParameters.campaign_id === undefined) {
            throw new runtime.RequiredError('campaign_id','Required parameter requestParameters.campaign_id was null or undefined when calling cancelCampaign.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/campaigns/{campaign_id}/cancel`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters.campaign_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignFromJSON(jsonValue));
    }

    /**
     * Cancel scheduled campaign
     */
    async cancelCampaign(requestParameters: CancelCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Campaign> {
        const response = await this.cancelCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create campaign
     */
    async createCampaignRaw(requestParameters: CreateCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Campaign>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createCampaign.');
        }

        if (requestParameters.CampaignCreateParams === null || requestParameters.CampaignCreateParams === undefined) {
            throw new runtime.RequiredError('CampaignCreateParams','Required parameter requestParameters.CampaignCreateParams was null or undefined when calling createCampaign.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/campaigns`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CampaignCreateParamsToJSON(requestParameters.CampaignCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignFromJSON(jsonValue));
    }

    /**
     * Create campaign
     */
    async createCampaign(requestParameters: CreateCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Campaign> {
        const response = await this.createCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create short link
     */
    async createShortLinkRaw(requestParameters: CreateShortLinkRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ShortLink>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createShortLink.');
        }

        if (requestParameters.ShortLinkCreateParams === null || requestParameters.ShortLinkCreateParams === undefined) {
            throw new runtime.RequiredError('ShortLinkCreateParams','Required parameter requestParameters.ShortLinkCreateParams was null or undefined when calling createShortLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/short_links`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShortLinkCreateParamsToJSON(requestParameters.ShortLinkCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShortLinkFromJSON(jsonValue));
    }

    /**
     * Create short link
     */
    async createShortLink(requestParameters: CreateShortLinkRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ShortLink> {
        const response = await this.createShortLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete campaign
     */
    async deleteCampaignRaw(requestParameters: DeleteCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteCampaign.');
        }

        if (requestParameters.campaign_id === null || requestParameters.campaign_id === undefined) {
            throw new runtime.RequiredError('campaign_id','Required parameter requestParameters.campaign_id was null or undefined when calling deleteCampaign.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/campaigns/{campaign_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters.campaign_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete campaign
     */
    async deleteCampaign(requestParameters: DeleteCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete short link
     */
    async deleteShortLinkRaw(requestParameters: DeleteShortLinkRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteShortLink.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteShortLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/short_links/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete short link
     */
    async deleteShortLink(requestParameters: DeleteShortLinkRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteShortLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all audience members
     */
    async findAudiencesRaw(requestParameters: FindAudiencesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AudienceMemberList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findAudiences.');
        }

        if (requestParameters.SegmentOptions === null || requestParameters.SegmentOptions === undefined) {
            throw new runtime.RequiredError('SegmentOptions','Required parameter requestParameters.SegmentOptions was null or undefined when calling findAudiences.');
        }

        const queryParameters: any = {};

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/audience`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SegmentOptionsToJSON(requestParameters.SegmentOptions),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AudienceMemberListFromJSON(jsonValue));
    }

    /**
     * List all audience members
     */
    async findAudiences(requestParameters: FindAudiencesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AudienceMemberList> {
        const response = await this.findAudiencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all campaigns
     */
    async findCampaignsRaw(requestParameters: FindCampaignsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CampaignList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findCampaigns.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.sent_lt !== undefined) {
            queryParameters['sent_lt'] = (requestParameters.sent_lt as any).toISOString();
        }

        if (requestParameters.sent_gt !== undefined) {
            queryParameters['sent_gt'] = (requestParameters.sent_gt as any).toISOString();
        }

        if (requestParameters.sent_lte !== undefined) {
            queryParameters['sent_lte'] = (requestParameters.sent_lte as any).toISOString();
        }

        if (requestParameters.sent_gte !== undefined) {
            queryParameters['sent_gte'] = (requestParameters.sent_gte as any).toISOString();
        }

        if (requestParameters.scheduled_lt !== undefined) {
            queryParameters['scheduled_lt'] = (requestParameters.scheduled_lt as any).toISOString();
        }

        if (requestParameters.scheduled_gt !== undefined) {
            queryParameters['scheduled_gt'] = (requestParameters.scheduled_gt as any).toISOString();
        }

        if (requestParameters.scheduled_lte !== undefined) {
            queryParameters['scheduled_lte'] = (requestParameters.scheduled_lte as any).toISOString();
        }

        if (requestParameters.scheduled_gte !== undefined) {
            queryParameters['scheduled_gte'] = (requestParameters.scheduled_gte as any).toISOString();
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/campaigns`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignListFromJSON(jsonValue));
    }

    /**
     * List all campaigns
     */
    async findCampaigns(requestParameters: FindCampaignsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CampaignList> {
        const response = await this.findCampaignsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find short link by id
     */
    async findOneAnalyticsShortLinkRaw(requestParameters: FindOneAnalyticsShortLinkRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ShortLinkAnalytics>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneAnalyticsShortLink.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneAnalyticsShortLink.');
        }

        if (requestParameters.date_macro === null || requestParameters.date_macro === undefined) {
            throw new runtime.RequiredError('date_macro','Required parameter requestParameters.date_macro was null or undefined when calling findOneAnalyticsShortLink.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.unit !== undefined) {
            queryParameters['unit'] = requestParameters.unit;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/short_links/{id}/analytics`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShortLinkAnalyticsFromJSON(jsonValue));
    }

    /**
     * Find short link by id
     */
    async findOneAnalyticsShortLink(requestParameters: FindOneAnalyticsShortLinkRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ShortLinkAnalytics> {
        const response = await this.findOneAnalyticsShortLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find campaign by id
     */
    async findOneCampaignRaw(requestParameters: FindOneCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Campaign>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneCampaign.');
        }

        if (requestParameters.campaign_id === null || requestParameters.campaign_id === undefined) {
            throw new runtime.RequiredError('campaign_id','Required parameter requestParameters.campaign_id was null or undefined when calling findOneCampaign.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/campaigns/{campaign_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters.campaign_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignFromJSON(jsonValue));
    }

    /**
     * Find campaign by id
     */
    async findOneCampaign(requestParameters: FindOneCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Campaign> {
        const response = await this.findOneCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find audience by campaign id
     */
    async findOneSegmentCampaignRaw(requestParameters: FindOneSegmentCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AudienceMemberList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneSegmentCampaign.');
        }

        if (requestParameters.campaign_id === null || requestParameters.campaign_id === undefined) {
            throw new runtime.RequiredError('campaign_id','Required parameter requestParameters.campaign_id was null or undefined when calling findOneSegmentCampaign.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/campaigns/{campaign_id}/audience`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters.campaign_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AudienceMemberListFromJSON(jsonValue));
    }

    /**
     * Find audience by campaign id
     */
    async findOneSegmentCampaign(requestParameters: FindOneSegmentCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AudienceMemberList> {
        const response = await this.findOneSegmentCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find short link by id
     */
    async findOneShortLinkRaw(requestParameters: FindOneShortLinkRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ShortLink>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneShortLink.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneShortLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/short_links/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShortLinkFromJSON(jsonValue));
    }

    /**
     * Find short link by id
     */
    async findOneShortLink(requestParameters: FindOneShortLinkRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ShortLink> {
        const response = await this.findOneShortLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all short links for program
     */
    async findShortLinksRaw(requestParameters: FindShortLinksRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ShortLinkList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findShortLinks.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.is_campaign !== undefined) {
            queryParameters['is_campaign'] = requestParameters.is_campaign;
        }

        if (requestParameters.campaign_id) {
            queryParameters['campaign_id'] = requestParameters.campaign_id;
        }

        if (requestParameters.unique_clicks_lt !== undefined) {
            queryParameters['unique_clicks_lt'] = requestParameters.unique_clicks_lt;
        }

        if (requestParameters.unique_clicks_gt !== undefined) {
            queryParameters['unique_clicks_gt'] = requestParameters.unique_clicks_gt;
        }

        if (requestParameters.unique_clicks_lte !== undefined) {
            queryParameters['unique_clicks_lte'] = requestParameters.unique_clicks_lte;
        }

        if (requestParameters.unique_clicks_gte !== undefined) {
            queryParameters['unique_clicks_gte'] = requestParameters.unique_clicks_gte;
        }

        if (requestParameters.clicks_lt !== undefined) {
            queryParameters['clicks_lt'] = requestParameters.clicks_lt;
        }

        if (requestParameters.clicks_gt !== undefined) {
            queryParameters['clicks_gt'] = requestParameters.clicks_gt;
        }

        if (requestParameters.clicks_lte !== undefined) {
            queryParameters['clicks_lte'] = requestParameters.clicks_lte;
        }

        if (requestParameters.clicks_gte !== undefined) {
            queryParameters['clicks_gte'] = requestParameters.clicks_gte;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/short_links`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShortLinkListFromJSON(jsonValue));
    }

    /**
     * List all short links for program
     */
    async findShortLinks(requestParameters: FindShortLinksRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ShortLinkList> {
        const response = await this.findShortLinksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Preview test campaign
     */
    async previewCampaignRaw(requestParameters: PreviewCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Message>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling previewCampaign.');
        }

        if (requestParameters.campaign_id === null || requestParameters.campaign_id === undefined) {
            throw new runtime.RequiredError('campaign_id','Required parameter requestParameters.campaign_id was null or undefined when calling previewCampaign.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling previewCampaign.');
        }

        const queryParameters: any = {};

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/campaigns/{campaign_id}/preview`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters.campaign_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Preview test campaign
     */
    async previewCampaign(requestParameters: PreviewCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Message> {
        const response = await this.previewCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Schedule campaign
     */
    async scheduleCampaignRaw(requestParameters: ScheduleCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Campaign>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling scheduleCampaign.');
        }

        if (requestParameters.campaign_id === null || requestParameters.campaign_id === undefined) {
            throw new runtime.RequiredError('campaign_id','Required parameter requestParameters.campaign_id was null or undefined when calling scheduleCampaign.');
        }

        if (requestParameters.CampaignScheduleParams === null || requestParameters.CampaignScheduleParams === undefined) {
            throw new runtime.RequiredError('CampaignScheduleParams','Required parameter requestParameters.CampaignScheduleParams was null or undefined when calling scheduleCampaign.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/campaigns/{campaign_id}/schedule`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters.campaign_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CampaignScheduleParamsToJSON(requestParameters.CampaignScheduleParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignFromJSON(jsonValue));
    }

    /**
     * Schedule campaign
     */
    async scheduleCampaign(requestParameters: ScheduleCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Campaign> {
        const response = await this.scheduleCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send campaign
     */
    async sendCampaignRaw(requestParameters: SendCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CampaignSentResult>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling sendCampaign.');
        }

        if (requestParameters.campaign_id === null || requestParameters.campaign_id === undefined) {
            throw new runtime.RequiredError('campaign_id','Required parameter requestParameters.campaign_id was null or undefined when calling sendCampaign.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/campaigns/{campaign_id}/send`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters.campaign_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignSentResultFromJSON(jsonValue));
    }

    /**
     * Send campaign
     */
    async sendCampaign(requestParameters: SendCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CampaignSentResult> {
        const response = await this.sendCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send test campaign
     */
    async sendTestCampaignRaw(requestParameters: SendTestCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling sendTestCampaign.');
        }

        if (requestParameters.campaign_id === null || requestParameters.campaign_id === undefined) {
            throw new runtime.RequiredError('campaign_id','Required parameter requestParameters.campaign_id was null or undefined when calling sendTestCampaign.');
        }

        if (requestParameters.CampaignSendTestParams === null || requestParameters.CampaignSendTestParams === undefined) {
            throw new runtime.RequiredError('CampaignSendTestParams','Required parameter requestParameters.CampaignSendTestParams was null or undefined when calling sendTestCampaign.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/campaigns/{campaign_id}/send_test`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters.campaign_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CampaignSendTestParamsToJSON(requestParameters.CampaignSendTestParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Send test campaign
     */
    async sendTestCampaign(requestParameters: SendTestCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.sendTestCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update campaign
     */
    async updateCampaignRaw(requestParameters: UpdateCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Campaign>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateCampaign.');
        }

        if (requestParameters.campaign_id === null || requestParameters.campaign_id === undefined) {
            throw new runtime.RequiredError('campaign_id','Required parameter requestParameters.campaign_id was null or undefined when calling updateCampaign.');
        }

        if (requestParameters.CampaignUpdateParams === null || requestParameters.CampaignUpdateParams === undefined) {
            throw new runtime.RequiredError('CampaignUpdateParams','Required parameter requestParameters.CampaignUpdateParams was null or undefined when calling updateCampaign.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/campaigns/{campaign_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters.campaign_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CampaignUpdateParamsToJSON(requestParameters.CampaignUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignFromJSON(jsonValue));
    }

    /**
     * Update campaign
     */
    async updateCampaign(requestParameters: UpdateCampaignRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Campaign> {
        const response = await this.updateCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update short link
     */
    async updateShortLinkRaw(requestParameters: UpdateShortLinkRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ShortLink>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateShortLink.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateShortLink.');
        }

        if (requestParameters.ShortLinkUpdateParams === null || requestParameters.ShortLinkUpdateParams === undefined) {
            throw new runtime.RequiredError('ShortLinkUpdateParams','Required parameter requestParameters.ShortLinkUpdateParams was null or undefined when calling updateShortLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/short_links/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ShortLinkUpdateParamsToJSON(requestParameters.ShortLinkUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShortLinkFromJSON(jsonValue));
    }

    /**
     * Update short link
     */
    async updateShortLink(requestParameters: UpdateShortLinkRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ShortLink> {
        const response = await this.updateShortLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
